import type { IPopup } from "@mm-frontend/mm-web-ui-kit";

export class SignInBlockedStepController {
  public popup: IPopup;

  constructor({ popup }: { popup: IPopup }) {
    this.popup = popup;
  }
}